import { atom, atomFamily } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

export const aiStateAtom = atom({
  key: RecoilAtomKey.aiStateKey,
  default: {
    ai_model: 'chatgpt',
    query: '',
    conversation_id: '',
    campaign_id: '',
    organisation_id: '',
    user_id: '',
    selectedOrganisation: null,
    selectedCampaign: null,
  },
});

export const projectAndQueryListAtom = atom({
  key: RecoilAtomKey.projectAndQueryListKey,
  default: {},
});
